module.exports = {
      id: "cancel-usage",
      viewBox: "0 0 241.171 241.171",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#cancel",
      toString: function () {
        return this.url;
      }
    }